
//import {db, functions} from "@/scripts/firebase";
import {Sequence, Playing} from "@/common-datatypes";
import { Component,Mixins,Prop, Watch } from "vue-property-decorator"
import {query, Unsubscribe, onSnapshot, getDoc, where} from 'firebase/firestore'
import Common from '@/mixins/common'

@Component({
  components: {
    
  }
})


export default class SequenceList extends Mixins(Common) {
  @Prop({type: String, default: ''}) private playingId?: string
  @Prop({type: String, default: ''}) private searchText?: string

  observers: (Unsubscribe | undefined)[] = []

  playing = {} as Playing

  sequences = [] as Sequence[]

  isLoading = false

  sequencesProps = {} as {[key: string]: {hidden: boolean}}

  async copyToClipboard(content: string){
    await window.navigator.clipboard.writeText(content)
  }

  get pages(){
    return this.sequences.map((sequence) => {
      try{
        if(sequence.title === 'scraping'){
          const pages = JSON.parse(sequence.content)
          if(Array.isArray(pages)){
            return pages
          }
        }
      }catch(e){
        return []
      }
      return []
    })
  }

  @Watch('searchText')
  changeSearchText(val: string){
    let searchResultsNum = 0
    this.sequences.forEach((sequence) => {
      if(sequence.docId){
        if(val.length === 0){
          this.sequencesProps[sequence.docId] = {hidden: false}
          return
        }

        if(sequence.content && sequence.content.indexOf(val) > -1){
          this.sequencesProps[sequence.docId] = {hidden: false}
          searchResultsNum ++
          return
        }

        this.sequencesProps = {
          ...this.sequencesProps,
          [sequence.docId]: {hidden: true}
        }
      }
    })
    this.$emit("onSearchResultsNum",searchResultsNum)
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      if(this.playingId){
        const playingDoc = await getDoc(this.$getPlayingDocRef(this.playingId))

        if(playingDoc.exists()){
          this.playing = {
            ...playingDoc.data() as Playing,
          }

          const sequencesQuery = query(this.$getSequencesColRef(),where("playingId","==",this.playingId))

          this.observers.push( onSnapshot(sequencesQuery,async (snapshot) => {
            snapshot.forEach((doc) => {
              const row = {
                ...doc.data(),
              } as Sequence

              const findIndex = this.sequences.findIndex((sequence) => {return sequence.docId === doc.id})
              const deleteCount = (findIndex === -1 ? 0 : 1)
              this.sequences.splice(findIndex,deleteCount,row)

              if(deleteCount === 0){
                  this.sequencesProps = {
                    ...this.sequencesProps,
                    [doc.id]: {hidden: false}
                  }
                }

              if(row.title === 'completion' || row.mode === row.title){
                this.$emit("onCompletion",true)
              }


              //sequencesをupdateTimeでソート
              //titleでソート
              this.sequences.sort((a,b) => {
                if(a.updateTime && b.updateTime){
                  return b.updateTime.getTime() - a.updateTime.getTime()
                }else{
                  return 0
                }
              })
              /*
              .sort((a,b) => {
                if(a.title && b.title && /-\d+$/.test(a.title) && /-\d+$/.test(b.title)){
                  return a.title.localeCompare(b.title)
                }else{
                  return 0
                }
              })
              */
            })
          
            this.$store.commit("setLoading",true);
            this.isLoading = true
            await this.$sleep(100)
            this.$store.commit("setLoading",false);
            this.isLoading = false
          }))
        }
      }
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  destroyed() {
    console.trace('destroyed')
    this.$unsubscriber(this.observers)
  }

}
